import React from 'react';
import { changelog } from '../data/changelog';
import './Changelog.css';

const Changelog: React.FC = () => {
  return (
    <div className="changelog-page">
      <div className="changelog-hero">
        <h1>Was ist neu?</h1>
        <p>Hier findest du alle wichtigen Änderungen und neuen Funktionen von Cruising Ducks.</p>
      </div>
      <div className="changelog-list">
        {changelog.map((entry) => (
          <article key={entry.date} className="changelog-card">
            <header>
              <time>{new Date(entry.date).toLocaleDateString('de-DE')}</time>
              <h2>{entry.title}</h2>
            </header>
            <ul>
              {entry.highlights.map((highlight, idx) => (
                <li key={idx}>{highlight}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Changelog;


